import { createContext, useContext } from 'react';

export const AdvertiserOnboardingContext = createContext(null);

export function useAdvertiserOnboarding() {
    const ctx = useContext(AdvertiserOnboardingContext);
    return ctx;
}
